import React, { useEffect } from "react"
import { useParams, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getBooking, cleanBooking } from "store/bookings"
import { cleanTrip, receivedTrip } from "store/trips"
import { TripsPreview } from "components/trips/TripsPreview"
import Spinner from "components/common/Spinner"
import { useTitle } from "hooks/useTitle"
import GuestHeader from "layoutsV2/client/GuestHeader"
import { Flex, Typography } from "antd"
import { useTheme } from "context/AntdThemeContext"
import { useTranslation } from "react-i18next"

const { Text } = Typography

const ClientGuestBookingConfirmation = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const location = useLocation()
  const { booking } = useSelector((store) => store.bookings)
  const { trip, loading } = booking
  const isLoggedIn = !!localStorage.getItem("access_token")
  const isEmbedded = location.pathname.includes("/embedded/")
  const { isSportsman } = useTheme()
  const { t } = useTranslation()
  useTitle(trip?.title)

  useEffect(() => {
    dispatch(getBooking(params.id)).then(({ trip }) => dispatch(receivedTrip(trip)))
    return () => dispatch(cleanBooking()) && dispatch(cleanTrip())
  }, [params.id, dispatch])

  if (loading)
    return (
      <Flex justify="center" align="center" className="min-vh-100">
        <Spinner />
      </Flex>
    )

  return (
    <main className="min-vh-100 bg-light">
      <GuestHeader hideUserControls={!isLoggedIn} />
      <div className="min-h-100 py-15 layout-wrapper">{booking.id && <TripsPreview />}</div>
      {isEmbedded && (
        <div className="layout-wrapper" style={{ paddingTop: "16px", paddingBottom: "16px" }}>
          <a href="https://dspro.guide" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>
            <Text>
              {t("settings.powered_by")} {isSportsman ? t("select_adventure_mode.sportsman") : t("select_adventure_mode.sportswoman")}
            </Text>
          </a>
        </div>
      )}
    </main>
  )
}

export default ClientGuestBookingConfirmation
